import { useEffect } from 'react';
import * as Router from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setMobileList } from 'redux/index';
import { excludeType } from 'helpers';
import { useCreateDispatches } from 'helpers/hooks';
import { SupportForm, SupportManual, SupportVideo } from './components';
import styles from './support.module.css';

const Support = ({ basePath = '/support', contactOnly = false }) => {
	const { supportId } = Router.useParams();
	const { push } = Router.useHistory();
	const dispatch = useDispatch();
	const { user } = useSelector(({ user }) => user);
	const { email } = user;
	const { setRoot } = useCreateDispatches();

	useEffect(() => {
		if (contactOnly) {
			setRoot('connect');
		}

		if (contactOnly && supportId !== 'contact') {
			push(`${basePath}/contact/`);
		} else if (!supportId) {
			if (excludeType(['child'])) {
				push(`${basePath}/contact/`);
			} else {
				push(`${basePath}/videos/`);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [basePath, contactOnly, supportId]);

	const onMobileNavBack = () => {
		dispatch(setMobileList(true));
	};

	return (
		<div className={styles.supportRoot}>
			<Router.Switch>
				<Router.Route path={`${basePath}/contact`}>
					<SupportForm email={email} navBack={onMobileNavBack} />
				</Router.Route>
				{!contactOnly && (
					<Router.Route path={`${basePath}/manual`}>
						<SupportManual navBack={onMobileNavBack} />
					</Router.Route>
				)}
				{!contactOnly && (
					<Router.Route path={`${basePath}/videos`}>
						<SupportVideo navBack={onMobileNavBack} />
					</Router.Route>
				)}
			</Router.Switch>
		</div>
	);
};

export default Router.withRouter(Support);
